<template lang="pug">
  section#desktop.section(:class="{'play': isReady}" data-pv="desktop")
    .section__outer

    .section__inner
      a.desktop__button.move-in(href="#" @click.prevent="openPopup({ type: 'scan' })")

</template>

<script>
import { mapState, mapActions } from 'vuex'
import { mixins } from '@/utils/mixins'

export default {
  name: 'Desktop',
  mixins: [mixins],
  props: {
  },
  watch: {
    isLoading() {
      this.init();
    }
  },
  data: () => {
    return {
      isReady: false,
    }
  },
  computed: {
    ...mapState(['isLoading']),
  },
  methods: {
    ...mapActions(['openPopup']),
    init() {
      this.isReady = true;
    },
    // goToNextPage() {
    //   this.$router.push('/next');
    // },
  },
  created() {
  },
  mounted() {
    const { init, isLoading, isReady } = this;
    if (!isLoading && !isReady) setTimeout(init, 500);
    if (this.$route.path !== '/') {
      this.$router.push('/');
    }
  },
  destroyed() {
  },
  components: {
  }
}
</script>

<style lang="scss">

$assets: '~@/assets/images/desktop/';

#desktop {

  height: calc(var(--vh, 1vh) * 100);
  min-height: 0;
  overflow: hidden;

  .section__inner {

    // position: relative;
    background: url($assets + 'image.png') no-repeat center center / auto 100%;

    @include desktop {
      height: calc(100% - 68px);
    }

  }

  .desktop__button {
    position: absolute;
    top: vhX(713);
    left: 50%;
    width: vhX(258);
    height: vhX(258);
    transform: translateX(-50%);
    background: url($assets + 'button.png') no-repeat 0 0 / contain;
    // transition: filter .15s linear;

    &::after {
      content: '';
      position: absolute;
      top: vhX(146);
      left: vhX(107);
      width: vhX(43);
      height: vhX(35);
      background: url($assets + 'button-arrow.png') no-repeat 0 0 / contain;
      animation: buttonArrow 1s ease-in-out infinite;
    }

    // @include hover {
      &:hover {
        filter: brightness(2);
        // transform: scale(1.1);
      }
    // }
  }

  // @keyframes buttonArrow {
  //   0%, 100% {
  //     transform: translateY(20%);
  //   }
  //   50% {
  //     transform: translateY(5%);
  //   }
  // }

}

</style>
